import React from 'react';
import { Grid, Typography, Box, useTheme, useMediaQuery } from '@mui/material';

import img1 from '../../Image/LandingPage/Image1.jpg';
import img2 from '../../Image/LandingPage/Image2.jpg';
import img3 from '../../Image/LandingPage/Image3.jpg';
import img4 from '../../Image/LandingPage/Image4.jpg';
import img5 from '../../Image/LandingPage/Image5.jpg';

const images = [
  {
    img: img1,
    title: 'Image 1',
    label: '4kW ongrid, Hathras (UP)',
    brand: 'Om Solar',
  },
  {
    img: img3,
    title: 'Image 3',
    label: '4kW ongrid, Hathras (UP)',
    brand: 'Om Solar',
  },
  {
    img: img2,
    title: 'Image 2',
    label: '4kW ongrid, Hathras (UP)',
    brand: 'Om Solar',
  },
  {
    img: img4,
    title: 'Image 4',
    label: '4kW ongrid, Hathras (UP)',
    brand: 'Om Solar',
  },
  {
    img: img5,
    title: 'Image 5',
    label: '4kW ongrid, Hathras (UP)',
    brand: 'Om Solar',
  },
];

const ImageContainer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ width: '100%', padding: { xs: 2, sm: 4 } }}>
      <Grid container spacing={2}>
        {images.slice(0, 2).map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: 3,
                overflow: 'hidden',
                height: 600,
                '&:hover .hover-text': {
                  opacity: 1,
                },
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                loading='lazy'
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              {/* <Box
                className='hover-text'
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  width: '100%',
                  bgcolor: 'rgba(0, 0, 0, 0.6)',
                  color: 'white',
                  px: 2,
                  py: 1,
                  opacity: isMobile ? 1 : 0,
                  transition: 'opacity 0.3s ease-in-out',
                }}
              >
                <Typography variant='body2'>{item.label}</Typography>
                <Typography variant='body1' fontWeight='bold'>
                  {item.brand}
                </Typography>
              </Box> */}
            </Box>
          </Grid>
        ))}

        {images.slice(2).map((item, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: 3,
                overflow: 'hidden',
                height: 200,
                '&:hover .hover-text': {
                  opacity: 1,
                },
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                loading='lazy'
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              {/* <Box
                className='hover-text'
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  width: '100%',
                  bgcolor: 'rgba(0, 0, 0, 0.6)',
                  color: 'white',
                  px: 2,
                  py: 1,
                  opacity: isMobile ? 1 : 0,
                  transition: 'opacity 0.3s ease-in-out',
                }}
              >
                <Typography variant='body2'>{item.label}</Typography>
                <Typography variant='body1' fontWeight='bold'>
                  {item.brand}
                </Typography>
              </Box> */}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ImageContainer;
